module.exports = __webpack_public_path__ + "img/product-brakepad-modal.9ce7ac2d.png";